var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['edit-online-badge', { expanded: _vm.hovered }]},[_c('img',{attrs:{"src":"https://cdn.vexels.com/img/cursor-click.png","alt":"Edit Online Badge","loading":"lazy"}}),_vm._v(" "),_c('span',{staticClass:"badge-text"},[_vm._v(_vm._s(_vm.$t('main.preview.content.editOnline')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }